import React, { useEffect, useState } from 'react';
import { initialMealsState, MealsState } from '../models/meals-state';
import { callApiWithData } from '../api/call-api';
import Meal, { mapMealFromApi } from '../models/meal';

export const MealsContext = React.createContext<MealsState>(initialMealsState);

interface MealsContextProviderProps {
  children: React.ReactNode;
}

export const MealsContextProvider = (props: MealsContextProviderProps) => {
  const [meals, setMeals] = useState<Meal[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const refresh = async () => {
    try {
      const initialMeals = await callApiWithData('/chef-meals', {}, 'POST');

      const meals: Meal[] = initialMeals.meals.map(mapMealFromApi);

      setMeals(meals);
    } finally {
      setIsLoading(false);
    }
  };

  const addMeal = (meal: Meal) => {
    setMeals((prevState: Meal[]) => {
      return [...prevState, meal];
    });
  };

  const findMeal = (id: string): Meal | null => {
    return meals.find((meal) => meal.id === id) ?? null;
  };

  useEffect(() => {
    refresh();
  }, []);

  return (
    <MealsContext.Provider
      value={{
        meals: meals,
        isLoading,
        addMeal,
        refresh,
        findMeal,
      }}
    >
      {props.children}
    </MealsContext.Provider>
  );
};

export default MealsContext;
